exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-value{color:var(--gray-7)}.header-title{font-size:16px}", ""]);

// exports
